import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios'
import { Link } from "react-router-dom";
//import { useToasts } from 'react-toast-notifications'
import { AuthContext } from '../../Auth/Auth'
//import { useQuery, useMutation, useQueryClient } from 'react-query'
//import { Form, Col, Row, Modal } from 'react-bootstrap'
import { globalConfig } from '../../../config/config'
import { Loading } from '../../Loading/Loading'
import {
  InputAdornment, Checkbox, TextareaAutosize,
  IconButton,
  TextField,
  Container,
  MenuItem,
  Tabs,
  Tab,
  Typography,
  Drawer, 
  InputLabel,
  Button
} from '@mui/material';

const ProblemTicketCreate = () => {

	return (
	
	<>


     <div class="container-fluid">
          <div className="d-flex flex-row justify-content-between mb-3 mt-3">
            <h4>Create Ticket</h4>
			  <div>
            <Link to="/eqius/tickets" className="btn-success btn">
              Search Tickets
            </Link>
            &nbsp;
            <Link to="/" className="btn-primary btn">
              Home
            </Link>
            &nbsp;
            <Link to="/eqius" className="btn-warning btn">
              Back
            </Link>
            &nbsp;
            <Link to="/eqius" className="btn-info btn">
              My Tickets
            </Link>
            </div>
          </div>


	<h4>Summary</h4>

 			<TextField 
 				sx={{m:2}}
 				fullWidth
 				label="Title"
 				styleClass="form-control input-big" id="title" value="#{ombProblemTicketForm.createProblemTicketBean.title }" ></TextField>
	  		<TextField 
	  			sx={{m:2}}
	  			fullWidth
	  			label="Due Date"
	  			styleClass="form-control input-medium date-picker" readonly='true' size='40' name="ticketDueDate" value="#{ombProblemTicketForm.createProblemTicketBean.ticketDueDate }"> 
	  			
	  		</TextField>

	  		<TextField 
 				sx={{m:2}}
 				fullWidth
	  			label="Work Queue"
	  			value="#{ombProblemTicketForm.createProblemTicketBean.workQueueId }">
					<option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('WORK_QUEUE')}"/>
  				</TextField>

	    	<TextField
 				sx={{m:2}}
 				fullWidth
	    		select 
	    		label="Type"
	    		value="#{ombProblemTicketForm.createProblemTicketBean.typeCode }">
				<option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('ISSUE_TYPE')}"/>
			</TextField>

	    	<TextField 
 				sx={{m:2}}
 				fullWidth
	    		select
	    		label="Priority"
	    		value="#{ombProblemTicketForm.createProblemTicketBean.priorityCode }">
				<option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('TASK_PRIORITY')}"/>
			</TextField>

	    	<TextField 
 				sx={{m:2}}
 				fullWidth
	    		select 
	    		label="Billing Code"
	    		value="#{ombProblemTicketForm.createProblemTicketBean.billingCode }">
				<option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('COST_CENTER_CODES')}"/>
			</TextField>
			
	</div>
	<hr />
	<h4>Stakeholders</h4>	   	  			
		   	  		    	<TextField 
 				sx={{m:2}}
 				fullWidth
		   	  		    	select 
		   	  		    	label="Reporter"
		   	  		    	value="#{ombProblemTicketForm.createProblemTicketBean.reporterId }">
		   	  		    	<option value="#{ombUsersSelectControl.getUserListByFirstLastName()}" />
		   	  		    	</TextField>

						
							<TextField 
 				sx={{m:2}}
 				fullWidth
							select  
							label="Reporter Type"
							value="#{ombProblemTicketForm.createProblemTicketBean.reporterTypeCode }">
							<option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('REPORTER_TYPE')}"/>
							</TextField>
		   	  			
		   	  		    	<TextField 
	 				sx={{m:2}}
 				fullWidth
	   	  		    	select
		   	  		    	label="Status Performer"
		   	  		    	value="#{ombProblemTicketForm.createProblemTicketBean.currentStatusUser }">
		   	  				<option value="#{ombUsersSelectControl.getUserListByFirstLastName()}" />
		   	  				</TextField>	
								   	  		
						
		   	  			
		   	  		    	<TextField 
 				sx={{m:2}}
 				fullWidth
		   	  		    	select 
		   	  		    	label="Status"
		   	  		    	value="#{ombProblemTicketForm.createProblemTicketBean.currentStatusCode }">
							<option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('ISSUE_STATUS')}"/>
		   	  				</TextField>
		   	  				
		   	  		
		   	  		
		   	  			
		   	  			
		   	  		    	<TextField 
 				sx={{m:2}}
 				fullWidth
		   	  		    	select 
		   	  		    	label="Disposition Performer"
		   	  		    	value="#{ombProblemTicketForm.createProblemTicketBean.currentDispositionUser }">
		   	  				<option value="#{ombUsersSelectControl.getUserListByFirstLastName()}" /> 
		   	  				</TextField>
		   	  			
		   	  			
		   	  		    	<TextField 
 				sx={{m:2}}
 				fullWidth
		   	  		    	select 
		   	  		    	label="Disposition"
		   	  		    	value="#{ombProblemTicketForm.createProblemTicketBean.currentDisposition }">
							<option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('ISSUE_DISPOSITION')}"/>
		   	  				</TextField>		   	  		
				
		   	  		
		   	  		    
		   	  		    
		   	  		    	<TextField 
 				sx={{m:2}}
 				fullWidth
		   	  		    	select 
		   	  		    	label="Approver"
		   	  		    	value="#{ombProblemTicketForm.createProblemTicketBean.approverId }">
		   	  		    	<option value="#{ombUsersSelectControl.getUserListByFirstLastName()}" />
		   	  		    	</TextField>
		   	  			<label></label>
		   	  			<label></label>
		   	  		
		   	  		    
		   	  		    
		   	  		   		<TextField 
 				sx={{m:2}}
 				fullWidth
		   	  		   		select 
		   	  		   		label="Owner"
		   	  		   		value="#{ombProblemTicketForm.createProblemTicketBean.ownerId }">
		   	  		    	<option value="#{ombUsersSelectControl.getUserListByFirstLastName()}" />
		   	  		    	</TextField>
	   	  		
		   	  			
		   	  			
		   	  				<TextField 
 				sx={{m:2}}
 				fullWidth
		   	  				select 
		   	  				label="Assignee"
		   	  				value="#{ombProblemTicketForm.createProblemTicketBean.assigneeId }">
		   	  				<option value="#{ombUsersSelectControl.getUserListByFirstLastName()}" />
		   	  				</TextField>
	<hr />
	<h4>Environment</h4>	   	  		

		   	  			
		   	  			
		   	  		    	<TextField 
 				sx={{m:2}}
 				fullWidth
		   	  		    	select 
		   	  		    	label="Environment"
		   	  		    	value="#{ombProblemTicketForm.createProblemTicketBean.environmentId }">
							<option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('ENVIRONMENTS')}"/>
		   	  				</TextField>
		   	  		    
		   	  		    
		   	  		    	<TextField 
 				sx={{m:2}}
 				fullWidth
		   	  		    	select 
		   	  		    	value="Operating System"
		   	  		    	value="#{ombProblemTicketForm.createProblemTicketBean.operatingSystemId }">
							<option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('OPERATING_SYSTEMS')}"/>
		   	  		    	</TextField>

	<h4>Description</h4>
		<TextareaAutosize   
 				sx={{m:2}}
			fullWidth
			style={{ width: 2000 }}
			styleClass="form-control input-xlarge"  id="description" value="#{ombProblemTicketForm.createProblemTicketBean.description }"></TextareaAutosize>

	<h4>Resolution</h4>	   	  			
		<TextareaAutosize 
 				sx={{m:2}}
 				fullWidth
			maxRows={4}
			style={{ width: 2000 }}
			styleClass="form-control input-xlarge" id="addNote" value="#{ombProblemTicketForm.createProblemTicketBean.newResolution}" />


<hr />
 				<Button color="success" variant="contained" value="Search" id="searchActor" onclick="selectTab('tab_results')"
					actionListener="#{ombProblemTicketForm.search}">Create</Button>&nbsp;
				<Button color="info" variant="contained" value="Clear" immediate="true" type="reset">Clear</Button>

 
	</>   
);
}

export default ProblemTicketCreate;